import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <p className="text-xs font-semibold text-primary-500 uppercase tracking-wider mb-2">GET IN TOUCH</p>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-900">{contactData.title}</h2>
          <p className="text-sm text-foreground-600 mt-3 max-w-lg mx-auto">{contactData.description}</p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-background-50 rounded-2xl border border-background-200/70 p-6 md:p-8">
            <div className="flex items-center gap-3 mb-6 pb-6 border-b border-background-200/70">
              <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center">
                <i className="ri-mail-line text-primary-600 text-xl"></i>
              </div>
              <div>
                <p className="text-xs text-foreground-500">反馈邮箱</p>
                <p className="text-sm font-medium text-foreground-900">{contactData.email}</p>
              </div>
            </div>

            <div className="space-y-3">
              <h4 className="text-sm font-semibold text-foreground-900">反馈须知：</h4>
              {contactData.tips.map((tip, i) => (
                <div key={i} className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line text-accent-500 text-sm mt-0.5 flex-shrink-0"></i>
                  <p className="text-xs text-foreground-600 leading-relaxed">{tip}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}